import { render, staticRenderFns } from "./admin_role.vue?vue&type=template&id=c8cc97dc&"
import script from "./admin_role.vue?vue&type=script&lang=js&"
export * from "./admin_role.vue?vue&type=script&lang=js&"
import style0 from "./admin_role.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports